import { StopTemplate } from "../models/stopTemplate";

export interface StopTemplatesService {
  getStopTemplate(stopTemplateId: string): StopTemplate | undefined
}

export function createStopTemplatesService() {
  return new StopTemplatesServiceImpl();
}

const stopTemplates = new Map<string, StopTemplate>();
stopTemplates.set('peacevans', {stopTemplateId: 'peacevans', googlePlaceId: "ChIJOZfTlYJqkFQRzkZ2LApPPfA" })
stopTemplates.set('olympic_nps', {stopTemplateId: 'olympic_nps', googlePlaceId: 'ChIJG-MG03Sxj1QRugKOz0SlbqM' })
stopTemplates.set('ncascadesnps', {stopTemplateId: 'ncascadesnps', googlePlaceId: 'ChIJqaAOwbnqhFQRSvLTtW8Aggs' })
stopTemplates.set('mountrainiernps', {stopTemplateId: 'mountrainiernps', googlePlaceId: 'ChIJrRbwoGzTkFQRswvHslZeox0'})

export class StopTemplatesServiceImpl {
  getStopTemplate(stopTemplateId: string) {
    return stopTemplates.get(stopTemplateId);
  }
}